module.exports = __webpack_public_path__ + "static/media/foto-premio-aragonenlared.cdd2fa2f.jpg";